import Loadable from '../../../components/loadable';

export default Loadable(() =>
  import(/* webpackChunkName: "layout-footer4business" */ './index')
);
